import { ErrorSchema, IChangeEvent, ISubmitEvent } from '@rjsf/core';
import { useDidMountEffect, useDirtyForm } from 'hooks';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { GenericDialog } from '../../dialog/GenericDialog';
import { GenericFormType } from '../GenericForm';

export const useGenericForm = (props: GenericFormType) => {

    const [ openDialog, setOpenDialog ] = useState<ISubmitEvent<any> | null>(null);
    const [value, setValue] = useState(props.value || props.defaultValue)
    const [defaultValue, setDefaultValue] = useState(props.defaultValue)
    const [isDirty, setIsDirty] = useState(false)
    const [dirtiesFields, setDirtiesFields] = useState<string []>()
    const { addDirty, removeDirty, hasDirty } = useDirtyForm()

    useEffect(() => {
        props.value && setValue(props.value)
    }, [props.value])

    useDidMountEffect(() => {
        
        setIsDirty(
            !_.isEqual(
                _.omitBy(defaultValue, (v) => (typeof v === 'object' || Array.isArray(v)) && _.isEmpty(v)), 
                _.omitBy(value, (v) => (typeof v === 'object' || Array.isArray(v)) && _.isEmpty(v))
            )
        )
    }, [value, defaultValue])

    useEffect(() => {
        if (props.isDirtyUx && !hasDirty) {
            setDefaultValue(value)
        }
    }, [hasDirty])

    useEffect(() => {
        if (props.isDirtyUx && props.id) {
            isDirty ? addDirty(props.id) : removeDirty(props.id)
        }
    }, [isDirty])

    const handleFormSubmit = async (e: ISubmitEvent<Record<string, any>>): Promise<void> => {
        if (props.dialog && !openDialog) {
            setOpenDialog(e)
            return;
        }

        if (props.dialog && openDialog) {
            setOpenDialog(null)
        }

        await props.onSubmit?.(value, e, dirtiesFields)
        setIsDirty(false)
        setDefaultValue(e.formData)
    };

    const handleFormChange = (e: IChangeEvent<Record<string, any>>, error?: ErrorSchema): void => {
        const tmpValue = e.formData
        const d = getDirtiesFields(defaultValue, tmpValue)
        setDirtiesFields(d)
        props.onChange?.(tmpValue, e, error, d)
        props.value === undefined && setValue(tmpValue)
    };

    const handleBackClick = ():void => {
        props.onBack?.()
    }

    const handleClose = ():void => setOpenDialog(null)

    const renderDialog = () : React.ReactChild | null => {
        if (!props.dialog) return null
        return (
            <GenericDialog
                open={openDialog !== null}
                dialog={props.dialog}
                onClose={handleClose}
                onSubmit={() => handleFormSubmit(openDialog as ISubmitEvent<Record<string, unknown>>)}
                />
        )
    }

    const getDirtiesFields = (oldValue: any, newValue: any) => {
        return Object.keys(newValue).map((item: any) => {
            if(newValue?.[item] != oldValue?.[item]) {
                return item
            }
        }).filter((item: any) => item != undefined)
    }

    return {
        value,
        setValue,
        isDirty,
        dirtiesFields,
        renderDialog,
        handleFormSubmit,
        handleFormChange,
        handleBackClick
    }
}
